import React from 'react';
import { WizardState } from '../../../hooks/useZakatWizard';
import { Input } from '../../ui/Input';
import { Card } from '../../ui/Card';
import { Info, AlertCircle } from 'lucide-react';
interface DebtsStepProps {
  state: WizardState;
  updateState: (updates: Partial<WizardState>) => void;
}
const displayVal = (v: number) => v === 0 ? '' : v;
export function DebtsStep({
  state,
  updateState
}: DebtsStepProps) {
  return <div className="space-y-6" data-id="element-289">
      <div className="mb-6" data-id="element-290">
        <h2 className="text-2xl font-bold text-gray-900 font-serif mb-2" data-id="element-291">
          Money I Owe (Debts)
        </h2>
        <p className="text-gray-600" data-id="element-292">
          Deduct debts that are due within the next 12 months. For long-term
          debts like mortgages, only include 12 months of payments.
        </p>
      </div>

      <div className="bg-amber-50 border border-amber-100 rounded-lg p-4 flex gap-3 text-sm text-amber-800 mb-6" data-id="element-293">
        <Info className="h-5 w-5 flex-shrink-0 mt-0.5" data-id="element-294" />
        <p data-id="element-295">
          Only immediate debts reduce your zakatable wealth. Long-term debts
          (like the full value of a mortgage) are generally not deducted in
          full—only the payments due in the coming lunar year.
        </p>
      </div>

      <div className="bg-teal-50 border border-teal-100 rounded-lg p-4 flex gap-3 text-sm text-teal-800 mb-6" data-id="element-296">
        <AlertCircle className="h-5 w-5 flex-shrink-0 mt-0.5" data-id="element-297" />
        <p data-id="element-298">
          <strong data-id="element-299">Why is this step always shown?</strong> Debts are deducted
          from your total assets before calculating Zakat, regardless of what
          asset types you own. This ensures your Zakat is calculated on your
          true net wealth.
        </p>
      </div>

      <Card className="space-y-6" data-id="element-300">
        <Input label="Credit Card Balances" prefix="$" type="number" placeholder="0.00" value={displayVal(state.creditCardDebt)} onChange={e => updateState({
        creditCardDebt: parseFloat(e.target.value) || 0
      })} data-id="element-301" />

        <Input label="Student Loans (Next 12 Months)" prefix="$" type="number" placeholder="0.00" value={displayVal(state.studentLoans)} onChange={e => updateState({
        studentLoans: parseFloat(e.target.value) || 0
      })} data-id="element-302" />

        <Input label="Car Loans (Next 12 Months)" prefix="$" type="number" placeholder="0.00" value={displayVal(state.carLoans)} onChange={e => updateState({
        carLoans: parseFloat(e.target.value) || 0
      })} data-id="element-303" />

        <Input label="Mortgage (Next 12 Months)" prefix="$" type="number" placeholder="0.00" value={displayVal(state.mortgage)} onChange={e => updateState({
        mortgage: parseFloat(e.target.value) || 0
      })} data-id="element-304" />

        <Input label="Personal Loans" prefix="$" type="number" placeholder="0.00" value={displayVal(state.personalLoans)} onChange={e => updateState({
        personalLoans: parseFloat(e.target.value) || 0
      })} data-id="element-305" />

        <Input label="Medical Bills / Other Debts" prefix="$" type="number" placeholder="0.00" value={displayVal(state.otherDebts)} onChange={e => updateState({
        otherDebts: parseFloat(e.target.value) || 0
      })} data-id="element-306" />
      </Card>
    </div>;
}